var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appup-datatable",staticStyle:{"display":"flex","flex-direction":"row"},attrs:{"id":_vm.id}},[_c('div',{staticStyle:{"overflow":"hidden","flex-grow":"1"}},[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":_vm.id,"gridOptions":_vm.gridOptions,"rowData":_vm.appupRowData}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/datatable/datatable.vue